var symphony = symphony || {};

;(function() {

  symphony.gmapPopulation = function() {

	var localSitesMap = {
		map: null,
		markers: [],
		data: [],
		icon: {
			size: new google.maps.Size(24,39),
			url: gdosWrapper.config.icon
		},
		activeIcon: {
			size: new google.maps.Size(24,39),
			url: '/templates/usa_nhq_symphony/static_resources/images/global/location-pin-active.png'
		},

		init: function() {
			var self = this;
			self.map = null;
			self.markers = [];
			self.data = window["globalLocalSites"];


			if(_.isNull(window["globalLocalSites"]) || _.isEmpty(window["globalLocalSites"]) || $('#localSites-map-iframe').length < 1){
				return;
			}

			self.map = new GMaps({
				div: '#localSites-map-iframe',
				lat: self.data[0].lat,
				lng: self.data[0].lng,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				disableDefaultUI: true
			});

			_(self.data).forEach(function(center) {
				var marker = self.map.addMarker({
					lat: center.lat,
					lng: center.lng,
					title: center.title,
					click: function(e) {
						_(self.map.markers).forEach(function(m) {
							m.setIcon(self.icon);
						});
						this.setIcon(self.activeIcon);
						$('.localSites-item.isActive').removeClass('isActive');
						$('#localSites-item-' + center.id).addClass('isActive');
						$('.localSites-items').animate({ 'scrollTop': $('#localSites-item-' + center.id).position().top }, 300);
					},
					icon: {
						size: new google.maps.Size(24,39),
						url: gdosWrapper.config.icon
					}
				});
				self.markers.push({id: center.id, marker: marker});
			});
			self.map.refresh();
			self.map.fitZoom();

			self.registerEvents();
		},

		registerEvents: function() {
			var self = this;

			$(document).on('click', '.localSites-item', function(e) {
				var id = $(this).data('id');

				var marker = $.grep(self.markers, function(m, i) { return m.id == id; })[0].marker;
				_(self.map.markers).forEach(function(m) {
					m.setIcon(self.icon);
				});
				marker.setIcon(self.activeIcon);

				var pos = marker.getPosition();
				self.map.setCenter(pos.lat(), pos.lng());

				$('.localSites-item.isActive').removeClass('isActive');
				$(this).addClass('isActive');
			});

			$('.localSites-map-container').on('click', function(){
				$(this).addClass('isDraggable');
			});
		}
	};
	
	localSitesMap.init();

  };


})();